import React, { Dispatch, FC, SetStateAction } from 'react'
import { Box, IconButton, TextField } from '@mui/material'
import SearchSmallIcon from 'ui/components/svg/SearchSmallIcon'
import ClearSvg from 'ui/components/svg/ClearSvg'
import { SearchBarWrapper } from './integrationsSelectSearch.styles'

interface Props {
  search: string
  placeholder: string
  setSearch: Dispatch<SetStateAction<string>>
}

const IntegrationsSelectSearch: FC<Props> = ({ search, placeholder, setSearch }) => {
  const inputHandler = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    setSearch(e.target.value)
  }

  return (
    <SearchBarWrapper className="search-bar-wrapper">
      <Box className="search-icon">
        <SearchSmallIcon />
      </Box>
      <TextField
        className="search-bar-text-field"
        value={search}
        placeholder={placeholder || 'Search'}
        onInput={(e) => inputHandler(e)}
        onKeyDown={(e) => e.stopPropagation()}
        autoFocus={false}
      />
      {search ? (
        <IconButton className="search-bar-clear-btn" onClick={() => setSearch('')}>
          <ClearSvg />
        </IconButton>
      ) : (
        ''
      )}
    </SearchBarWrapper>
  )
}

export default IntegrationsSelectSearch
